// extracted by mini-css-extract-plugin
export default {"root":"SpinningWheel_root__KFvSc","wheelImg":"SpinningWheel_wheelImg__LTZtk","wheelContainer":"SpinningWheel_wheelContainer__EZNv3","animate":"SpinningWheel_animate__dBUAe"};